import RichUpdatesItemShare from './RichUpdatesItemShare';

export default RichUpdatesItemShare;



// WEBPACK FOOTER //
// ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShare/index.tsx